import { render, staticRenderFns } from "./merDetailModal.vue?vue&type=template&id=3c1b5b8c&scoped=true&"
import script from "./merDetailModal.vue?vue&type=script&lang=js&"
export * from "./merDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./merDetailModal.vue?vue&type=style&index=0&id=3c1b5b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b5b8c",
  null
  
)

export default component.exports